module.exports = __webpack_public_path__ + "static/123-01-01-1d1e046a1461c603ea9c174ac52f39d0.png";